/** @jsxImportSource @emotion/react */

import { isEmpty } from 'lodash';

import styled from '@emotion/styled';

import { FormFieldsItem, FormFieldsItemType } from './FormFieldsItem';

interface FormFieldsProps {
    items: FormFieldsItemType[];
}

export const FormFields = ({ items }: FormFieldsProps) => {
    if (isEmpty(items)) return null;

    return (
        <>
            {items.map((item) => {
                /**
                 * Some inputs cannot be styled directly, in order to style
                 * them easly the `data-field-type` attribute is applied to
                 * every form field.
                 *
                 * Then we can style those inputs  like:
                 * @example [data-field-type="file"] { // styles }
                 */
                const dataFieldProp = {
                    ...(item.component === 'FormField' && {
                        'data-field-type': item.type,
                    }),
                };

                return (
                    <FormFieldsItemWrapper key={item._uid} {...dataFieldProp}>
                        <FormFieldsItem item={item} />
                    </FormFieldsItemWrapper>
                );
            })}
        </>
    );
};

const FormFieldsItemWrapper = styled.div`
    &:not(:last-of-type) {
        margin: 0 0 20px;
    }
`;
